<template>
  <el-dialog
    title="新建房源信息"
    :visible.sync="dialogVisible"
    width="85%"
    :close-on-click-modal="false"
    @close="handleClose"
    class="add-house-dialog"
    top="3vh"
  >
    <div class="dialog-content-wrapper">
      <vue-perfect-scrollbar class="scroll-area" :settings="scrollSettings">
        <el-form
          ref="formRef"
          :model="formData"
          :rules="formRules"
          label-width="auto"
          size="small"
          class="add-form"
        >
          <!-- ====== 基础信息 ====== -->
          <div class="form-section">
            <div class="section-title">基础信息</div>

            <el-row :gutter="30">
               <!-- 第0行：房屋地址（占2列） -->
              <el-col :span="24">
                <el-form-item label="房屋地址" prop="房屋地址">
                  <el-input v-model="formData.房屋地址" placeholder="请输入房屋地址" />
                </el-form-item>
              </el-col>
              <!-- 第1行：产权证地址（占2列） -->
              <!-- <el-col :span="24">
                <el-form-item label="产权证地址" prop="产权证地址">
                  <el-input v-model="formData.产权证地址" placeholder="请输入产权证地址" />
                </el-form-item>
              </el-col>
               -->
              <!-- 第2行：不动产权号 + 丘权号 -->
              <el-col :span="12">
                <el-form-item label="不动产权号" prop="不动产权号">
                  <el-input v-model="formData.不动产权号" placeholder="请输入不动产权号" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="丘权号" prop="丘权号">
                  <el-input v-model="formData.丘权号" placeholder="请输入丘权号" />
                </el-form-item>
              </el-col>
              
              <!-- 第3行：所在区（占2列，与详情页一致）  + 业务状态 --> 
          <el-col :span="12">
            <el-form-item label="行政区" prop="行政区">
              <el-select v-model="formData.行政区" placeholder="请选择行政区" clearable style="width:100%">
                <el-option label="青秀区" value="青秀区" />
                <el-option label="兴宁区" value="兴宁区" />
                <el-option label="江南区" value="江南区" />
                <el-option label="良庆区" value="良庆区" />
                <el-option label="邕宁区" value="邕宁区" />
                <el-option label="西乡塘区" value="西乡塘区" />
                <el-option label="武鸣区" value="武鸣区" />
                <el-option label="横州市" value="横州市" />
                <el-option label="宾阳县" value="宾阳县" />
                <el-option label="上林县" value="上林县" />
                <el-option label="马山县" value="马山县" />
                <el-option label="隆安县" value="隆安县" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="业务状态" prop="业务状态">
              <el-select v-model="formData.业务状态" placeholder="请选择业务状态" style="width:100%">
                <el-option label="待出租" value="待出租" />
                <el-option label="已出租" value="已出租" />
                <el-option label="已到期" value="已到期" />
                <el-option label="已中止" value="已中止" />
                  <el-option label="已预定" value="已预定" />
                <el-option label="装修中" value="装修中" />
                <el-option label="其他" value="其他" />
              </el-select>
            </el-form-item>
          </el-col>
                        
              <!-- 第4行：出房指导价 + 收房指导价 -->
              <el-col :span="12">
                <el-form-item label="出房指导价" prop="出房指导价">
                  <el-input-number
                    v-model="formData.出房指导价"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入出房指导价"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收房指导价" prop="收房指导价">
                  <el-input-number
                    v-model="formData.收房指导价"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入收房指导价"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              
              <!-- 第5行：收房人 + 收房门店 -->
              <el-col :span="12">
                <el-form-item label="收房人" prop="收房人">
                  <el-input v-model="formData.收房人" placeholder="请输入收房人" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="收房门店" prop="收房门店">
                  <el-input v-model="formData.收房门店" placeholder="请输入收房门店" />
                </el-form-item>
              </el-col>
              
              <!-- 第6行：室 + 厅 + 卫 + 面积（平米） -->
              <el-col :span="6">
                <el-form-item label="室" prop="室">
                  <el-input-number
                    v-model="formData.室"
                    :min="0"
                    :max="99"
                    :step="1"
                    placeholder="室"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="厅" prop="厅">
                  <el-input-number
                    v-model="formData.厅"
                    :min="0"
                    :max="99"
                    :step="1"
                    placeholder="厅"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="卫" prop="卫">
                  <el-input-number
                    v-model="formData.卫"
                    :min="0"
                    :max="99"
                    :step="1"
                    placeholder="卫"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="面积（平米）" prop="面积（平米）">
                  <el-input-number
                    v-model="formData['面积（平米）']"
                    :min="0"
                    :precision="2"
                    :step="1"
                    placeholder="面积"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              
              <!-- 第7行：楼层信息（第X层 + 共X层）+ 用途 + 朝向 -->
              <el-col :span="6">
                <el-form-item label="第X层" prop="楼层信息_第X层">
                  <el-input-number
                    v-model="formData.楼层信息_第X层"
                    :min="1"
                    :max="99"
                    :step="1"
                    placeholder="第X层"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="共X层" prop="楼层信息_共X层">
                  <el-input-number
                    v-model="formData.楼层信息_共X层"
                    :min="1"
                    :max="99"
                    :step="1"
                    placeholder="共X层"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用途" prop="用途">
                  <el-select v-model="formData.用途" placeholder="请选择用途" style="width:100%">
                    <el-option label="住宅" value="住宅" />
                    <el-option label="公寓" value="公寓" />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="朝向" prop="朝向">
                  <el-select v-model="formData.朝向" placeholder="请选择朝向" style="width:100%">
                    <el-option label="东" value="东" />
                    <el-option label="南" value="南" />
                    <el-option label="西" value="西" />
                    <el-option label="北" value="北" />
                    <el-option label="东南" value="东南" />
                    <el-option label="东北" value="东北" />
                    <el-option label="西南" value="西南" />
                    <el-option label="西北" value="西北" />
                    <el-option label="东西" value="东西" />
                    <el-option label="南北" value="南北" />
                    <el-option label="其他" value="其他" />
                  </el-select>
                </el-form-item>
              </el-col>
              
              <!-- 第8行：水卡 + 电卡用户名 + 电卡 + 气卡 -->
              <el-col :span="6">
                <el-form-item label="水卡" prop="水卡">
                  <el-input v-model="formData.水卡" placeholder="请输入水卡" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="气卡" prop="气卡">
                  <el-input v-model="formData.气卡" placeholder="请输入气卡" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="电卡" prop="电卡">
                  <el-input v-model="formData.电卡" placeholder="请输入电卡" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="电卡用户名" prop="电卡用户名">
                  <el-input v-model="formData.电卡用户名" placeholder="请输入电卡用户名" />
                </el-form-item>
              </el-col>
              
              <!-- 第9行：其他卡（占2列）+ 钥匙/密码（占2列） -->
              <el-col :span="12">
                <el-form-item label="其他卡" prop="其他卡">
                  <el-input v-model="formData.其他卡" placeholder="请输入其他卡" />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="钥匙/密码" prop="钥匙/密码">
                  <el-input v-model="formData['钥匙/密码']" placeholder="请输入钥匙/密码" />
                </el-form-item>
              </el-col>
              
              <!-- 第10行：备注（占2列） -->
              <el-col :span="24">
                <el-form-item label="备注" prop="备注">
                  <el-input v-model="formData.备注" type="textarea" :rows="2" placeholder="请输入备注" />
                </el-form-item>
              </el-col>
            </el-row>
          </div>

          <!-- ====== 收房详情 ====== -->
          <div class="form-section">
            <div class="section-title">收房详情</div>
           <!-- 第1行：产权人（占2列） -->
<el-row :gutter="20">
  <el-col :span="24">
    <el-form-item label="产权人" prop="房东姓名">
      <el-input v-model="formData.房东姓名" placeholder="请输入产权人" />
    </el-form-item>
  </el-col>
</el-row>

<!-- 第2行：产权人电话 + 产权人身份证号 -->
<el-row :gutter="20">
  <el-col :span="12">
    <el-form-item label="产权人电话" prop="房东电话">
      <el-input v-model="formData.房东电话" placeholder="请输入产权人电话" />
    </el-form-item>
  </el-col>
  <el-col :span="12">
    <el-form-item label="产权人身份证号" prop="产权人身份证号">
      <el-input v-model="formData.产权人身份证号" placeholder="请输入产权人身份证号" />
    </el-form-item>
  </el-col>
</el-row>

<!-- 第3行：受托代理人姓名 + 委托人电话 + 送达地址 -->
<el-row :gutter="20">
  <el-col :span="8">
    <el-form-item label="受托代理人姓名" prop="受托代理人姓名">
      <el-input v-model="formData.受托代理人姓名" placeholder="请输入受托代理人姓名" />
    </el-form-item>
  </el-col>
  <el-col :span="8">
    <el-form-item label="委托人电话" prop="委托人电话">
      <el-input v-model="formData.委托人电话" placeholder="请输入委托人电话" />
    </el-form-item>
  </el-col>
  <el-col :span="8">
    <el-form-item label="送达地址" prop="送达地址">
      <el-input v-model="formData.送达地址" placeholder="请输入送达地址" />
    </el-form-item>
  </el-col>
</el-row>
       <!-- 第4行：收房渠道 + 收房费用 + 合同编号 -->
    <el-row :gutter="20">
      <el-col :span="8">
        <el-form-item label="收房渠道" prop="收房渠道">
          <el-select v-model="formData.收房渠道" placeholder="请选择收房渠道" style="width:100%">
            <el-option label="中介" value="中介" />
            <el-option label="外网" value="外网" />
            <el-option label="老客户介绍" value="老客户介绍" />
            <el-option label="续签" value="续签" />
            <el-option label="其他" value="其他" />
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="收房费用" prop="收房费用">
          <el-input-number
            v-model="formData.收房费用"
            :min="0"
            :precision="2"
            :step="100"
            placeholder="请输入收房费用"
            controls-position="right"
            style="width:100%"
          />
        </el-form-item>
      </el-col>
      <el-col :span="8">
        <el-form-item label="合同编号" prop="合同编号">
          <el-input v-model="formData.合同编号" placeholder="请输入合同编号" />
        </el-form-item>
      </el-col>
    </el-row>
              
             <!-- 第5行：合同起始日 + 合同到期日（缩短宽度，保证在一行） -->
         <el-row :gutter="20">
  <!-- 合同起始日：占一半 -->
  <el-col :span="12">
    <el-form-item label="合同起始日" prop="合同起始日">
      <el-date-picker
        v-model="formData.合同起始日"
        type="date"
        placeholder="请选择合同起始日"
        value-format="timestamp"
        style="width:95%"
      />
    </el-form-item>
  </el-col>
  <!-- 合同到期日：占另一半 -->
  <el-col :span="12">
    <el-form-item label="合同到期日" prop="合同到期日">
      <el-date-picker
        v-model="formData.合同到期日"
        type="date"
        placeholder="请选择合同到期日"
        value-format="timestamp"
        style="width:95%"
      />
    </el-form-item>
  </el-col>
</el-row>
              <!-- 第6行：第一年免租期（天）+ 第二年免租期（天）+ 第三年免租期（天） -->
              <el-col :span="8">
                <el-form-item label="第一年免租期（天）" prop="第一年免租期（天）">
                  <el-input-number
                    v-model="formData['第一年免租期（天）']"
                    :min="0"
                    :max="365"
                    :step="1"
                    placeholder="天数"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="第二年免租期（天）" prop="第二年免租期（天）">
                  <el-input-number
                    v-model="formData['第二年免租期（天）']"
                    :min="0"
                    :max="365"
                    :step="1"
                    placeholder="天数"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="第三年免租期（天）" prop="第三年免租期（天）">
                  <el-input-number
                    v-model="formData['第三年免租期（天）']"
                    :min="0"
                    :max="365"
                    :step="1"
                    placeholder="天数"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              
              <!-- 第7行：免租期备注（占2列） -->
              <el-col :span="24">
                <el-form-item label="免租期备注" prop="免租期备注">
                  <el-input v-model="formData.免租期备注" placeholder="请输入免租期备注" />
                </el-form-item>
              </el-col>
              
              <!-- 第8行：押金 + 收房租金（元/月） + 支付周期 -->
              <el-col :span="8">
                <el-form-item label="押金" prop="押金">
                  <el-input-number
                    v-model="formData.押金"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入押金"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="收房租金（元/月）" prop="收房租金（元/月）">
                  <el-input-number
                    v-model="formData['收房租金（元/月）']"
                    :min="0"
                    :precision="2"
                    :step="100"
                    placeholder="请输入收房租金"
                    controls-position="right"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="支付周期" prop="支付周期">
                  <el-select v-model="formData.支付周期" placeholder="请选择支付周期" style="width:100%">
                    <el-option label="按月" value="按月" />
                    <el-option label="按季" value="按季" />
                    <el-option label="按半年" value="按半年" />
                    <el-option label="按年" value="按年" />
                  </el-select>
                </el-form-item>
              </el-col>
              
              <!-- 第9行：特别约定（占2列） -->
              <el-col :span="24">
                <el-form-item label="特别约定" prop="特别约定">
                  <el-input v-model="formData.特别约定" type="textarea" :rows="2" placeholder="请输入特别约定" />
                </el-form-item>
              </el-col>
              
              <!-- 第10行：支付户名 + 银行卡号 + 开户行 -->
              <el-col :span="8">
                <el-form-item label="支付户名" prop="支付户名">
                  <el-input v-model="formData.支付户名" placeholder="请输入支付户名" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="银行卡号" prop="银行卡号">
                  <el-input v-model="formData.银行卡号" placeholder="请输入银行卡号" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="开户行" prop="开户行">
                  <el-input v-model="formData.开户行" placeholder="请输入开户行" />
                </el-form-item>
              </el-col>
              
              <!-- 第11行：交房日期（占2列）+ 是否开通燃气（占2列）与详情页一致 -->
              <el-col :span="12">
                <el-form-item label="交房日期" prop="交房日期">
                  <el-date-picker
                    v-model="formData.交房日期"
                    type="date"
                    placeholder="请选择交房日期"
                    value-format="timestamp"
                    style="width:100%"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="是否开通燃气" prop="是否开通燃气">
                  <el-select v-model="formData.是否开通燃气" placeholder="请选择" style="width:100%">
                    <el-option label="是" value="是" />
                    <el-option label="否" value="否" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </vue-perfect-scrollbar>
    </div>

    <!-- ====== 底部按钮 ====== -->
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确认</el-button>
    </span>

    <!-- ====== 二次确认弹窗 ====== -->
    <el-dialog
      title="提示"
      :visible.sync="confirmDialog.visible"
      width="420px"
      :append-to-body="true"
      :close-on-click-modal="false"
    >
      <div style="text-align: center; padding: 20px 0;">
        <i class="el-icon-warning" style="font-size: 48px; color: #e6a23c;" />
        <p style="margin-top: 16px; font-size: 16px; color: #303133;">
          请核实输入的信息，点击提交后不可撤回。
        </p>
      </div>
      <span slot="footer">
        <el-button @click="confirmDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirmSubmit" :loading="submitting">确认</el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar' 
import { sqlBaseApi } from '@/api/通用/sqlBaseApi'

export default {
  name: 'AddSfHouse',
  components: {
    VuePerfectScrollbar
  },
  
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  
  data() {
    const validateContractDate = (rule, value, callback) => {
      if (!value || !this.formData.合同起始日) {
        callback()
        return
      }
      if (value <= this.formData.合同起始日) {
        callback(new Error('合同到期日必须大于合同起始日'))
      } else {
        callback()
      }
    }
    
    return {
      dialogVisible: this.visible,
      submitting: false,
      
     
      scrollSettings: {
        wheelSpeed: 1,
        swipeEasing: true,
        suppressScrollX: false,
        wheelPropagation: false,
        // 新增以下配置
        useBothWheelAxes: false,
        minScrollbarLength: 20,
        maxScrollbarLength: 100,
        // 关键：让滚动条不阻挡点击
        suppressScrollY: false,
        stopPropagationOnClick: false
      },
      
      formData: {
        产权证地址: '',
        不动产权号: '',
        丘权号: '',
        行政区: '',
        业务状态: '装修中',  // 新增，默认装修中
        出房指导价: null,
        收房指导价: null,
        收房人: '',
        收房门店: '',
        房屋地址: '',
        室: null,
        厅: null,
        卫: null,
        '面积（平米）': null,
        楼层信息_第X层: null,
        楼层信息_共X层: null,
        用途: '住宅',
        朝向: '东',
        是否开通燃气: '是',
        水卡: '',
        电卡用户名: '',
        电卡: '',
        气卡: '',
        其他卡: '',
        '钥匙/密码': '',
        备注: '',
        房东姓名: '',
        房东电话: '',
        产权人身份证号: '',
        受托代理人姓名: '',
        委托人电话: '',
        送达地址: '',
         合同编号: '',
        收房渠道: '中介',
        收房费用: null,
        合同起始日: null,
        合同到期日: null,
        '第一年免租期（天）': null,
        '第二年免租期（天）': null,
        '第三年免租期（天）': null,
        免租期备注: '',
        押金: null,
        '收房租金（元/月）': null,
        支付周期: '按月',
        特别约定: '',
        支付户名: '',
        银行卡号: '',
        开户行: '',
        交房日期: null
      },
      
      formRules: {
        房屋地址: [
          { required: true, message: '请输入房屋地址', trigger: 'blur' }
        ],
        合同起始日: [
          { required: true, message: '请选择合同起始日', trigger: 'change' }
        ],
        合同到期日: [
          { required: true, message: '请选择合同到期日', trigger: 'change' },
          { validator: validateContractDate, trigger: 'change' }
        ],
        支付周期: [
          { required: true, message: '请选择支付周期', trigger: 'change' }
        ],
        '收房租金（元/月）': [
          { required: true, message: '请输入收房租金', trigger: 'blur' }
        ]
      },
      
      confirmDialog: {
        visible: false
      }
    }
  },
  
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      this.$emit('update:visible', val)
      if (!val) {
        this.resetForm()
      }
    }
  },
  
  methods: {
    resetForm() {
      this.formData = {
        产权证地址: '',
        不动产权号: '',
        丘权号: '',
        行政区: '',
        出房指导价: null,
        收房指导价: null,
        收房人: '',
        收房门店: '',
        房屋地址: '',
        室: null,
        厅: null,
        卫: null,
        '面积（平米）': null,
        楼层信息_第X层: null,
        楼层信息_共X层: null,
        用途: '住宅',
        朝向: '东',
        是否开通燃气: '是',
        水卡: '',
        电卡用户名: '',
        电卡: '',
        气卡: '',
        其他卡: '',
        '钥匙/密码': '',
        备注: '',
        房东姓名: '',
        房东电话: '',
        产权人身份证号: '',
        受托代理人姓名: '',
        委托人电话: '',
        送达地址: '',
        收房渠道: '中介',
        收房费用: null,
        合同起始日: null,
        合同到期日: null,
        '第一年免租期（天）': null,
        '第二年免租期（天）': null,
        '第三年免租期（天）': null,
        免租期备注: '',
        押金: null,
        '收房租金（元/月）': null,
        支付周期: '按月',
        特别约定: '',
        支付户名: '',
        银行卡号: '',
        开户行: '',
        交房日期: null
      }
      this.confirmDialog.visible = false
      this.submitting = false
      this.$nextTick(() => {
        if (this.$refs.formRef) {
          this.$refs.formRef.clearValidate()
        }
      })
    },
    
    handleCancel() {
      const hasData = Object.values(this.formData).some(val => {
        if (val === null || val === '' || val === undefined) return false
        if (Array.isArray(val) && val.length === 0) return false
        return true
      })
      
      if (hasData) {
        this.$confirm('确定要取消吗？已填写的数据将丢失。', '提示', {
          type: 'warning'
        }).then(() => {
          this.dialogVisible = false
        }).catch(() => {})
      } else {
        this.dialogVisible = false
      }
    },
    
    handleClose() {
      this.dialogVisible = false
    },
    
    handleSubmit() {
      this.$refs.formRef.validate((valid) => {
        if (!valid) {
          this.$message.warning('请完善表单信息')
          return
        }
        this.confirmDialog.visible = true
      })
    },
    
    // ====== 确认提交 - 调用后端API ======
    handleConfirmSubmit() {
      this.submitting = true
      
      const submitData = this.buildSubmitData()
      console.log('提交数据===', submitData)
      
      // 调用新增API
      sqlBaseApi.insert(submitData).then((res) => {
        console.log('新增返回===', res)
        
        if (res.code === 200) {
          this.$message.success('新增成功！' )
          this.confirmDialog.visible = false
          this.dialogVisible = false
          // 通知父组件刷新列表
          this.$emit('refresh')
        } else {
          this.$message.error(res.message || '新增失败')
        }
      }).catch((err) => {
        console.error('新增请求失败===', err)
        this.$message.error(err.message || '新增失败，请稍后重试')
      }).finally(() => {
        this.submitting = false
      })
    },
    
  // ====== 构建提交数据 ======
buildSubmitData() {
  const data = { ...this.formData }
  
  // 处理楼层信息：分别提交两个独立字段
  // 前端字段名 -> 后端字段名
  // 楼层信息_第X层 -> 楼层信息（第X层）
  // 楼层信息_共X层 -> 楼层信息（共X层）
  const floorX = data.楼层信息_第X层
  const floorTotal = data.楼层信息_共X层
  
  // 删除前端临时字段
  delete data.楼层信息_第X层
  delete data.楼层信息_共X层
  
  // 添加后端需要的字段（仅当有值时）
  if (floorX !== null && floorX !== undefined && floorX !== '') {
    data['楼层信息（第X层）'] = floorX
  }
  if (floorTotal !== null && floorTotal !== undefined && floorTotal !== '') {
    data['楼层信息（共X层）'] = floorTotal
  }
  
  // 处理日期：时间戳转为秒（后端需要秒级时间戳）
  if (data.合同起始日) {
    data.合同起始日 = Math.floor(data.合同起始日 / 1000)
  }
  if (data.合同到期日) {
    data.合同到期日 = Math.floor(data.合同到期日 / 1000)
  }
  if (data.交房日期) {
    data.交房日期 = Math.floor(data.交房日期 / 1000)
  }
  
  // 移除空值字段（null/undefined/空字符串），保持数据干净
  Object.keys(data).forEach(key => {
    if (data[key] === null || data[key] === undefined || data[key] === '') {
      delete data[key]
    }
  })
  
  return {
    tableName: '房源',
    data: data
  }
}
  }
}
</script>

<style scoped>
.add-house-dialog /deep/ .el-dialog {
  max-height: 94vh;
  display: flex;
  flex-direction: column;
}

.add-house-dialog /deep/ .el-dialog__body {
  flex: 1;
  overflow: hidden;
  padding: 20px 20px 10px 20px;
}

.add-house-dialog /deep/ .el-dialog__footer {
  border-top: 1px solid #ebeef5;
  padding: 12px 20px;
}

.dialog-content-wrapper {
  height: 68vh;
  overflow: hidden;
}

.scroll-area {
  height: 100%;
  padding-right: 10px;
}

/* ====== 表单分组 ====== */
.form-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  padding: 10px 0;
  margin-bottom: 16px;
  border-bottom: 2px solid #409EFF;
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 60px;
  height: 2px;
  background: #409EFF;
}

/* ====== Label 自适应宽度 ====== */
.add-form /deep/ .el-form-item {
  margin-bottom: 18px;
}

.add-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #606266;
  padding-right: 12px;
  white-space: nowrap;
  /* label 宽度自适应，由 label-width="auto" 控制 */
}

/* ====== 输入框占满 ====== */
.add-form /deep/ .el-input-number {
  width: 100%;
}

.add-form /deep/ .el-input-number .el-input__inner {
  text-align: left;
}

.add-form /deep/ .el-select {
  width: 100%;
}

.add-form /deep/ .el-date-editor {
  width: 100%;
}

/* ====== 二次确认弹窗图标 ====== */
.el-icon-warning {
  color: #e6a23c;
}

/* ====== 响应式 ====== */
@media (max-width: 768px) {
  .add-house-dialog /deep/ .el-dialog {
    width: 95% !important;
  }
  
  .dialog-content-wrapper {
    height: 50vh;
  }
}
/* 修复滚动区域点击问题 */
.scroll-area {
  height: 100%;
  padding-right: 10px;
  /* 确保滚动容器不阻挡点击事件 */
  pointer-events: auto;
}

.scroll-area /deep/ .ps {
  pointer-events: auto;
}

.scroll-area /deep/ .ps__rail-x,
.scroll-area /deep/ .ps__rail-y {
  pointer-events: none !important;
  z-index: 10;
}

/* 确保表单元素可以正常交互 */
.add-form /deep/ .el-form-item {
  pointer-events: auto;
}

.add-form /deep/ .el-input,
.add-form /deep/ .el-select,
.add-form /deep/ .el-date-editor,
.add-form /deep/ .el-input-number {
  pointer-events: auto;
}
.scroll-area /deep/ .ps__rail-x,
.scroll-area /deep/ .ps__rail-y {
  z-index: 1 !important;
}

.scroll-area /deep/ .ps__thumb-x,
.scroll-area /deep/ .ps__thumb-y {
  z-index: 2 !important;
}
</style>